module.exports = __webpack_public_path__ + "img/triple-opal-necklace.8e8bd421.jpg";